import { Column } from '@tempmee/react';
import { Outlet } from 'react-router';
import { AuthHeaderNav } from '../AuthHeaderNav';

export interface IAuthShellProps {
  /** Controls the header chrome variant. @default 'default' */
  variant?: 'default' | 'forgot-password';
}

export const AuthShell = ({ variant = 'default' }: IAuthShellProps = {}) => (
  <Column style={{ minHeight: '100vh' }}>
    <AuthHeaderNav variant={variant} />
    <Outlet />
  </Column>
);
